import script from "./ContentMetadata.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContentMetadata.vue?vue&type=script&lang=ts&setup=true"

import "./ContentMetadata.vue?vue&type=style&index=0&id=0e2f9379&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e2f9379"]])

export default __exports__